import styled from 'styled-components';
import { StyledLoadingPlaceholder } from '@tryhackme/thm-ui-components';

export const StyledArticleCategoryLoading = styled.div`
  ${StyledLoadingPlaceholder}
  width: 18rem;
  height: 3.6rem;
`;

export const StyledArticleLoading = styled.div`
  padding-top: 2.5rem;
  width: 100%;
`;

export const StyledLoadLine = styled.span<{ width?: string }>`
  ${StyledLoadingPlaceholder};
  width: ${({ width }) => width || '50%'};
  height: 3.9rem;
  display: block;
  margin-bottom: 1.8rem;

  &:nth-child(5) {
    margin-bottom: 5.3rem;
  }
`;
